<template>
  <div class="scroll-x-box">
    <div
      class="mind-class-content clearfix"
      :style="'width:' + scrollXWidth + 'px;' + 'left:' + left + 'px'"
    >
      <div
        v-for="(each, index) in data"
        :key="index"
        @click="clickCreated(each, index)"
        class="modal-box-children"
      >
        <div class="gray-box"></div>
        <div
          v-if="
            !(
              each.layoutType == 4 &&
              each.mindType == 1 &&
              each.isEmpty == true
            )
          "
          class=""
          :style="
            'width: 132px;height: 80px;background:url(' +
            each.icon +
            ') no-repeat;background-size: 132px 80px;background-position:center;overflow:hidden;'
          "
        ></div>
        <div
          v-else
          class=""
          :style="
            'width: 132px;height: 80px;background:url(' +
            each.icon +
            ') no-repeat;background-size: cover;background-position:center;overflow:hidden;'
          "
        >
          <div class="empty-text">
            {{ getString(strings.My_Mind_Blank_Mind_Map) }}
          </div>
        </div>
        <div v-if="(each.explain != null && each.explain.length > 0)" 
          class="item-explain" >

          {{each.explain}}
        </div>
      </div>
    </div>
    <div
      v-if="showBoxWidth < scrollXWidth"
      @click="scrollRight"
      class="left-scroll-button"
    >
      <a-icon type="left" />
    </div>
    <div
      v-if="showBoxWidth < scrollXWidth"
      @click="scrollLeft"
      class="right-scroll-button"
    >
      <a-icon type="right" />
    </div>
    <a-modal
      class="report-member-model"
      :centered="true"
      v-model="storageIsMeberModelAccout"
      :title="getString(strings.Mind_Edit_Join_Membership)"
      :cancelText="getString(strings.Global_Cancel)"
      :okText="getString(strings.Mind_Edit_Upgrade)"
      @cancel="storageIsMeberCancelHandleOk"
      @ok="storageIsMeberDeleteHandleOk"
    >
      <div class="report-crisps-style-box">
        <div
          class="report-crisps-style"
          style="
            font-size: 18px;
            font-family: Noto Sans SC;
            text-align: center;
            display: block;
          "
        >
          {{ getString(strings.Insufficient_Storage_Space) }}
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
// each.icon.indexOf('left_right_layout_empty') < 0

import { mapMutations } from "vuex";
import strings from "../../../common/lang/strings";
import getString from "../../../common/lang/language";
import { postMindmapNewByType } from "../../../common/netWork/mind_map_api";
import { postMindmapListDir } from "../../../common/netWork/networkcache";
import ConfigurationItem from "../../../assets/js/ConfigurationItem.js";
const { numberOfMapsTourist } = ConfigurationItem;
import { getJwt } from "../../../common/netWork/base";
import XJMindFIleImport from '../../../core/core/dataformat/fileImport/XJMindFIleImport';
import NewXJMindMap from '../../../core/core/dataformat/fileImport/NewXJMindMap';
import NewLocalMindParameter from '../../../core/core/dataformat/fileImport/NewLocalMindParameter';

if (
  typeof navigator === "object" &&
  typeof navigator.userAgent === "string" &&
  navigator.userAgent.indexOf("Electron") >= 0
) {
  var { ipcRenderer } = window.require("electron");
  // var ipcRenderer = window.ipcRenderer
}
// const {ipcRenderer} = window.require('electron')
export default {
  name: "CreatedFileScroll",
  props: {
    data: {
      type: Array,
    },
    folder: {
      type: Object,
    },
    storageCloud: {
      type: Boolean,
    },
  },
  data() {
    return {
      left: 0,
      fullWidth: document.documentElement.clientWidth,
      showBoxWidth: document.documentElement.clientWidth - 215,
      clickButton: true,
      src: require("../../../../static/img/mapIcon/res/mipmap-xxhdpi/left_right_layout_5.jpg"),
      src1: "../../../../static/img/mapIcon/res/mipmap-xxhdpi/left_right_layout_5.jpg",
      befroeString: "../",
      urlPrefix: "../../../static/img/mapIcon/res/mipmap-xxhdpi/", //地址前缀
      strings,
      storageIsMeberModelAccout: false, //存储空间不足提示框
      createAMap: true, //创建一个导图
    };
  },
  created() {},
  mounted() {
    this.bus.$on("fullWidth", (msg) => {
      this.fullWidth = msg;
    });
  },
  methods: {
    ...mapMutations(["isShowShoppingModel", "refreshMyMindList"]),
    //语言包
    getString(i) {
      return getString(i);
    },
    storageIsMeberCancelHandleOk() {
      this.storageIsMeberModelAccout = false;
    },
    storageIsMeberDeleteHandleOk() {
      this.storageIsMeberModelAccout = false;
      this.isShowShoppingModel(true);
    },
    clickCreated(item, index) {
      if (item.path != null && item.path.length > 0) {
        this.clickCaseTemplate(item, index)
        return
      }
      let parentEntityId = this.folder.id; //  父文件夹id,默认为空
      let type = item.mindType; //  导图类型
      let mindDisplayType = item.mindDisplayType; //  导图模式
      let nodeLayoutType = item.layoutType; //  导图布局
      let lineLayout = item.lineLayout; //  线条类型
      let isEmpty = item.isEmpty; //  是否是空导图
      let styleIndex = item.styleIndex; //  styleIndex
      let data = {
        parentEntityId,
        type,
        mindDisplayType,
        nodeLayoutType,
        lineLayout,
        isEmpty,
        styleIndex,
      };
      // folder
      if (!this.storageCloud) { //只创建到本地
        var name = item.name;
        if ((typeof name) == "number") {
            try {
              name = getString(name)
            } catch (error) {
              name = name + "";
            }
        }
        let newLocalMindParameter = new NewLocalMindParameter()
        newLocalMindParameter.parentEntityId = parentEntityId
        newLocalMindParameter.type = type
        newLocalMindParameter.mindDisplayType = mindDisplayType
        newLocalMindParameter.nodeLayoutType = nodeLayoutType
        newLocalMindParameter.lineLayout = lineLayout
        newLocalMindParameter.isEmpty = isEmpty
        newLocalMindParameter.styleIndex = styleIndex
        let parameter = newLocalMindParameter.getJson()
        new NewXJMindMap(name, type, this.$router.appPath, parameter).createLocalMindMap().then((creearData) => {

        })
        return
      }
      // 未登录导图数量超过1个弹出登陆，否则不能创建
      postMindmapListDir(
        { parentId: "" },
        (res) => {
          localStorage.setItem("mapsNumber", res.entities.length);
        },
        (e) => {
          this.$message.error(e.desc);
        }
      );
      const mapsNumber = localStorage.getItem("mapsNumber") || 0;
      if (mapsNumber >= numberOfMapsTourist && !getJwt("jwt")) {        
        this.$store.state.showLogin = true;
        return;
      }
      if (this.$tools.isElectron()) {
        
        postMindmapNewByType(
          data,
          (res) => {
            ipcRenderer.send(
              "openCalendarWindow",
              "/mindmap?id=" + res.mindMapId
            );
            this.refreshMyMindList();
          },
          (error) => {
            if (error.code == 51) {
              this.storageIsMeberModelAccout = true;
            } else {
              this.$message.error(error.desc);
            }
          }
        );
      } else {
        postMindmapNewByType(
          data,
          (res) => {
            const routerData = this.$router.resolve({
              path: "/mindmap",
              query: {
                id: res.mindMapId,
              },
            });
            this.createATagJump(routerData.href);
            this.refreshMyMindList();
          },
          (error) => {
            if (error.code == 51) {
              this.storageIsMeberModelAccout = true;
            } else {
              this.$message.error(error.desc);
            }
          }
        );
      }
    },

    clickCaseTemplate(item, index) {
      // 未登录导图数量超过1个弹出登陆，否则不能创建
      postMindmapListDir(
        { parentId: "" },
        (res) => {
          localStorage.setItem("mapsNumber", res.entities.length);
        },
        (e) => {
          this.$message.error(e.desc);
        }
      );
      const mapsNumber = localStorage.getItem("mapsNumber") || 0;
      if (mapsNumber >= numberOfMapsTourist && !getJwt("jwt")) {        
        this.$store.state.showLogin = true;
        return;
      }
      if (this.$tools.isElectron()) {        
        ipcRenderer.send(
          "openCalendarWindow",
          "/template/?id=" + item.path
        );
      } else {
            const routerData = this.$router.resolve({
              path: "/template",
              query: {
                id: item.path,
              },
            });
            this.createATagJump(routerData.href);
      }
    },

    createATagJump(url) {
      const a = document.createElement("a"); //创建a标签浏览器不会阻止弹出窗口
      a.setAttribute("href", url);
      a.setAttribute("target", "_blank");
      document.body.appendChild(a);
      a.click();
      setTimeout(() => {
        document.body.removeChild(a);
      }, 5000);
    },
    scrollLeft() {
      if (this.clickButton == false) {
        return;
      }
      this.clickButton = false;
      let count = 0;
      let timer = setInterval(() => {
        if (this.scrollXWidth - this.showBoxWidth < -this.left) {
          this.left = -(this.scrollXWidth - this.showBoxWidth);
          this.clickButton = true;
          clearInterval(timer);
        } else {
          this.left -= 13.5;
        }
        count++;
        if (count == 9) {
          clearInterval(timer);
          this.clickButton = true;
        }
      }, 50);
    },
    scrollRight() {
      if (this.clickButton == false) {
        return;
      }
      this.clickButton = false;
      let count = 0;
      let timer = setInterval(() => {
        if (0 <= this.left) {
          this.left = 0;
          this.clickButton = true;
          clearInterval(timer);
        } else {
          this.left += 13.5;
        }
        count++;
        if (count == 9) {
          clearInterval(timer);
          this.clickButton = true;
        }
      }, 50);
    },
    //新手引导创建一个双向导图
    createABidirectionalMap() {
      if (this.createAMap) {
        this.clickCreated(this.data[1], 1);
      }
      this.createAMap = false;
    },
  },
  watch: {
    fullWidth: function (val) {
      this.showBoxWidth = val - 215;
    },
    "$store.state.createABidirectionalMap"(newVal) {
      if (newVal) {
        this.createABidirectionalMap();
        this.$store.state.createABidirectionalMap = false;
      }
    },
  },
  computed: {
    scrollXWidth: function () {
      return this.data.length * 230;
    },
  },
};
</script>

<style lang="less" scoped>
.scroll-x-box {
  position: relative;
  // height: 160px;
  overflow: hidden;
  padding: 0 15px 0 15px;
}
.left-scroll-button,
.right-scroll-button {
  position: absolute;
  top: 50%;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  color: #666;
  text-align: center;
  line-height: 50px;
  background-color: #fff;
  text-align: center;
  cursor: pointer;
  box-shadow: 1px 1px 2px #999;
  display: none;
}
.left-scroll-button {
  left: 0;
  transform: translate(0, -50%);
}
.right-scroll-button {
  right: 0;
  transform: translate(0, -50%);
}
.mind-class-content {
  position: absolute;
  display: contents;
  /* width: 600px;
    height: 135px; */
  /* display: flex; */
  /* justify-content: space-between; */
  /* flex-wrap:nowrap; */
}
.modal-box-children {
  float: left;
  /* width: 120px;
  height: 105px; */
  width: 132px;
  height: 80px;
  margin: 10px 0px 10px 15px;
  border-radius: 8px;
  // box-shadow: 0 0 6px #ccc;
  border: 1px solid #e7e7e7;
  box-shadow: 0px 0px 2px 2px #00000010;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  .empty-text {
    margin: 0 auto;
    margin-top: 90px;
    font-size: 16px;
    text-align: center;
  }
  .gray-box {
    display: none;
  }
  // &:hover .gray-box {
  //   position: absolute;
  //   z-index: 2;
  //   width: 200px;
  //   height: 125px;
  //   border-radius: 6px;
  //   display: block;
  //   background-color: rgba(0, 0, 0, 0.08);
  //   &:active {
  //     position: absolute;
  //     z-index: 2;
  //     width: 200px;
  //     height: 125px;
  //     border-radius: 6px;
  //     display: block;
  //     background-color: rgba(0, 0, 0, 0.2);
  //   }
  // }
}
.modal-box-children:hover {
  // box-shadow: 0 0 12px #ccc;
  border: 1px solid rgba(59, 59, 59, 0.3);
  box-shadow: 0px 0px 0px 0px #00000010;
  .gray-box {
    display: block;
    width: 132px;
    height: 80px;
    position: absolute;
    background: rgba(59, 59, 59, 0.2);
  }
}

.mind-class-content > i {
  width: 120px;
  margin-right: 20px;
  margin-left: 20px;
}
.item-explain {
  position: absolute;
  display: block;
  left: 0px;
  bottom: 0px;
  text-align: center;
  width: 100%;
  height: 20px;
  background-color: #0a0a0a7d;
  color: #fff;
  font-size: 12px
}
</style>